"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValidDataVariantRows = getValidDataVariantRows;
exports.isValid = isValid;
exports.createPropertyFilter = createPropertyFilter;
const property_1 = require("@genesys/property");
function getValidDataVariantRows(rows, properties) {
    return rows.filter(r => isValid(r.propertyFilter, property_1.PropertyFilter.Empty, properties));
}
function isValid(filter, fallbackFilter, selectedProperties) {
    return property_1.PropertyFilter.isValid(selectedProperties, createPropertyFilter(filter, fallbackFilter));
}
function createPropertyFilter(filter, fallbackFilter) {
    if (filter === null || filter === undefined || typeof filter === "string") {
        return ((filter !== undefined &&
            filter !== null &&
            property_1.PropertyFilter.fromString(filter)) ||
            fallbackFilter);
    }
    return filter;
}
//# sourceMappingURL=index.js.map